import React from 'react'
import { useAuth } from '../../hooks/useAuth'

export default function Adscend() {

    const { user } = useAuth();
  return (
    <iframe width="100%" height="1000px" src={`https://asmwall.com/adwall/publisher/116430/profile/19743?subid1=${user.id}`} allow="camera https://asmwall.com;" frameborder="0" allowfullscreen></iframe>
  )
}